<template>
  <div v-html="richData.content" class="content"></div>
</template>

<script>
import { getPbEducationHistoryId } from '@/api/educational'

export default {
  name: 'RichText',
  data () {
    return {
      richData: ''
    }
  },
  mounted () {
    this.getRich()
    console.log(this.$route)
  },
  methods: {
    async getRich () {
      const { result } = await getPbEducationHistoryId(this.$route.params.id)
      console.log(result)
      this.richData = result
    }
  }
}
</script>

<style lang="scss" scoped>
  .content {
    padding: 0 20px;
    box-sizing: border-box;
    ::v-deep img {
      max-width: 100%;
      height: auto;
    }
  }
</style>
